import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'leaderboards', component: () => import('../pages/LeaderboardPage.vue'), meta: { title: 'Leaderboards' } },
  { path: '/party', name: 'party', component: () => import('../pages/PartyPage.vue'), meta: { title: 'Party' } },
  { path: '/friends', name: 'friends', component: () => import('../pages/FriendsPage.vue'), meta: { title: 'Friends' } },
  { path: '/runs', name: 'runs', component: () => import('../pages/RunsPage.vue'), meta: { title: 'My runs' } },
  { path: '/me', name: 'profile', component: () => import('../pages/ProfilePage.vue'), meta: { title: 'Profile' } },
  { path: '/connect', name: 'connect', component: () => import('../pages/ConnectPage.vue'), meta: { title: 'Connect desktop' } },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('../pages/NotFoundPage.vue'), meta: { title: 'Not found' } },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

router.afterEach(to => {
  const title = typeof to.meta.title === 'string' ? to.meta.title : '';
  document.title = title ? `${title} · Garmoth Community` : 'Garmoth Community';
});
